import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { environment } from '../environments/environment';

const InnisionPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{sky.50}',
      100: '{sky.100}',
      200: '{sky.200}',
      300: '{sky.300}',
      400: '{sky.400}',
      500: '#00a3e0',
      600: '#0092c9',
      700: '#007fb0',
      800: '#006d97',
      900: '#005a7e',
      950: '#003d56',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#00a3e0',
          contrastColor: '#ffffff',
          hoverColor: '#0092c9',
          activeColor: '#007fb0',
        },
      },
      dark: {
        primary: {
          color: '#00a3e0',
          contrastColor: '#ffffff',
          hoverColor: '#33b5e7',
          activeColor: '#66c8ed',
        },
      },
    },
    fontFamily: "'Montserrat', sans-serif",
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    providePrimeNG({
      theme: {
        preset: InnisionPreset,
      },
    }),
  ],
};
